// Client logos with actual uploaded images - removed POST
const clients = [
  { 
    name: "RELATED", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/m0baz91x_Screenshot%202026-04-08%20at%203.01.30%E2%80%AFPM.png"
  },
  { 
    name: "Welden Field", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/24i2a38s_Screenshot%202026-04-08%20at%203.01.05%E2%80%AFPM.png"
  },
  { 
    name: "TREDWAY", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/6v7kyi9f_Screenshot%202026-04-08%20at%203.01.46%E2%80%AFPM.png"
  },
  { 
    name: "ASSET", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/lydcbylv_Screenshot%202026-04-08%20at%203.01.39%E2%80%AFPM.png"
  },
  { 
    name: "ARBOR", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/imfrjkl9_Screenshot%202026-04-08%20at%203.14.44%E2%80%AFPM.png"
  },
  { 
    name: "SPM", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/u5k4m9io_Screenshot%202026-04-08%20at%203.14.53%E2%80%AFPM.png"
  },
  { 
    name: "Brookside Properties", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/kiwdsr1j_Screenshot%202026-04-08%20at%203.14.27%E2%80%AFPM.png"
  },
  { 
    name: "Peachtree Property Ventures", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/cbl20stj_image.png"
  },
  { 
    name: "GOSource", 
    logo: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/ywqti4sv_image.png"
  }
];

const stats = [
  { value: "10,000+", label: "Units Renovated" },
  { value: "3", label: "Days to Renovate" },
  { value: "4,000+", label: "Unit Capacity/Year" },
  { value: "27%", label: "Below Market Cost" }
];

const ProjectsSection = () => {
  return (
    <section 
      id="projects" 
      className="section-padding bg-white"
      data-testid="projects-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-cyan-600 font-semibold text-sm tracking-widest uppercase mb-4 block">
            Track Record
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-6">
            Trusted by{" "}
            <span className="text-cyan-600">Industry Leaders</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            We've partnered with top multifamily owner-operators across the country, 
            delivering consistent results at scale.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="text-center p-6 bg-slate-50 rounded-lg border border-slate-200"
              data-testid={`stat-${index}`}
            >
              <div className="text-3xl sm:text-4xl font-bold text-cyan-600 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-slate-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Client Logos - Bigger size */}
        <div className="bg-slate-50 rounded-lg p-8 lg:p-12 border border-slate-200">
          <h4 className="text-center font-semibold text-slate-700 mb-10 text-lg">
            Our Partners & Clients
          </h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-10 items-center justify-items-center">
            {clients.map((client, index) => (
              <div
                key={index}
                className="client-logo text-center p-4 hover:scale-105 transition-transform flex items-center justify-center h-24"
                data-testid={`client-${index}`}
              >
                {client.logo ? (
                  <img 
                    src={client.logo} 
                    alt={client.name}
                    className="max-h-20 max-w-full object-contain transition-all opacity-70 hover:opacity-100"
                    style={{ mixBlendMode: 'multiply' }}
                  />
                ) : (
                  <div className="text-xl font-bold text-slate-400 hover:text-cyan-600 transition-colors tracking-tight">
                    {client.name}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
